<template>
  <button
    class="w-full select-none justify-center items-center cursor-pointer focus:outline-none hover:bg-primary-50 dark:hover:bg-dark-400"
    :class="{
      'text-primary': isDisabled,
      'text-aoj dark:text-dark-text-dark': !isDisabled,
      'py-4 px-1': displayHeight >= 840,
      'py-2 px-2': displayHeight < 840
    }"
    :disabled="isDisabled"
    style="transition: background-color 0.25s"
    @keydown.enter.exact.prevent="click"
  >
    <span class="material-icons" :class="displayHeight >= 840 ? 'text-4xl' : 'text-2xl'"> {{ icon }} </span>
    <div class="text-sm font-bold" :style="{ fontSize: displayHeight >= 840 ? '14px' : '10px' }">
      {{ text }}
    </div>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'

export default defineComponent({
  name: 'SideMenuButton',
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },

  setup(props, ctx) {
    const { windowHeight: displayHeight } = useConfigStatePresenter()

    const click = () => {
      ctx.emit('click')
    }

    return {
      displayHeight,
      click
    }
  }
})
</script>

<style lang="postcss" scoped></style>
